export default {
    common: {
        home: '首页',
        mainMenu: '主菜单',
        inbox: '我的收件箱',
        requests: '请求',
        reports: '报告',
        settings: '设置',
        accesses: '访问权限',
        flowAdmin: '流程管理',
        states: '状态',
        documents: '文档',
        reviewers: '审核人',
        close: '关闭',
        save: '保存',
        edit: '编辑',
        delete: '删除',
        detail: '详情',
        actions: '操作',
        status: '状态',
        value: '金额',
        area: '区域',
        creatorUser: '创建人',
        search: '搜索',
        comments: '评论',
        yes: '是',
        no: '否',
        loading: '加载中...',
        saving: '保存中...',
        requiredField: '此字段为必填项',
        requiredOption: '请选择一个选项',
        na: '不适用'
    },
    menu: {
        report1: '报告 1',
        report2: '报告 2',
        dashboardReport: '仪表板报告'
    },
    solicitud: {
        title: '合作备忘录申请',
        registerRequest: '登记申请',
        createRequest: '创建申请',
        updateRequest: '更新申请',
        requestDetail: '申请详情',
        generalInfo: '基本信息',
        processInfo: '流程信息',
        attachments: '附件',
        tracking: '跟踪',
        trackingProcess: '流程跟踪',
        trackingList: '跟踪列表',
        registerComment: '登记评论',
        timeline: '时间线',
        reviewers: '审核人',
        titleField: '标题',
        project: '项目',
        grant: '资助',
        amount: '金额',
        object: '目的',
        donor: '捐助方',
        responsible: '负责人',
        implementingPartner: '执行合作伙伴',
        additionalComments: '附加评论',
        requestDate: '申请日期',
        recordDate: '登记日期',
        consecutive: '编号',
        creatorArea: '创建人 / 部门',
        registerCommentBtn: '登记评论',
        saveDraft: '保存草稿',
        draftSaved: '草稿保存成功',
        requestSaved: '申请保存成功',
        commentSaved: '评论保存成功',
        saveError: '保存申请时出错。',
        commentSaveError: '保存评论时出错。',
        deleteConfirmTitle: '确认删除',
        deleteConfirmText: '确定要删除此记录吗？',
        editTooltip: '编辑',
        detailTooltip: '详情',
        deleteTooltip: '删除',
        approvedRequest: '已批准的申请',
        noActionsAvailable: '此状态下没有可用操作。',
        attachAgreement: '附加合作备忘录',
        observations: '备注',
        user: '用户',
        from: '来自',
        result: '结果',
        initialState: '初始状态',
        finalState: '最终状态',
        date: '日期',
        bp: 'BP',
        unitedId: '联合国ID',
        validationDate: '验证日期',
        applicationFrom: '申请编号',
        agreementNumber: '协议编号',
        policyAttach: '附加政策文件',
        receiptAttach: '附加付款收据',
        maAttach: '附加 MA',
        fields: {
            searchLabel: '按标题和/或编号搜索'
        },
        validations: {
            draftMin: '保存草稿时，必须至少填写标题和金额。',
            attachAgreementRequired: '必须附加合作备忘录。',
            actionObservationRequired: '必须为此操作输入备注。',
            bpUnitedDateRequired: '批准时必须填写 BP、联合国ID 和验证日期。',
            returnObservationRequired: '退回时必须填写备注。',
            returnFieldsEmpty: '退回时 BP / 联合国ID / 验证日期必须为空。',
            applicationFromRequired: '必须填写申请编号。',
            agreementRequired: '必须填写协议编号。',
            stateApprovedNeedBp: '申请批准时必须填写 BP',
            stateApprovedNeedUnited: '申请批准时必须填写联合国ID',
            stateApprovedNeedDate: '申请批准时必须填写验证日期',
            requiredPolicy: '必须附加政策文件',
            requiredReceipt: '必须附加付款收据',
            requiredMA: '必须附加 MA'
        },
        actions: {
            approve: '批准',
            send: '发送',
            create: '创建',
            finish: '完成',
            liquidate: '结算',
            return: '退回',
            reject: '拒绝',
            cancel: '取消'
        },
        results: {
            canceled: '已取消',
            request: '申请',
            received: '已接收',
            comment: '评论',
            finished: '已完成',
            returned: '已退回',
            code: '代码'
        },
        excelHeaders: {
            actions: '操作',
            status: '状态',
            consecutive: '编号',
            title: '标题',
            requestDate: '申请日期',
            value: '金额',
            grant: '资助',
            area: '区域',
            creatorUser: '创建人'
        }
    }
}